import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { getRemoveObjectsFromLessonMutationOptions, useRemoveObjectsFromLessonMutation, } from 'api';
import { DeletionConfirmationDialog } from 'components/custom';
import { enqueueSnackbar } from 'notistack';
const RemoveObjectsDialog = (props) => {
    const { t } = useTranslation('coursePlanning', {
        keyPrefix: 'deletionConfirmationDialog',
    });
    const [unlinkObject, statusUnlinkObject] = useRemoveObjectsFromLessonMutation();
    const onDelete = (lesson) => {
        const objectIds = lesson.objects.map((obj) => obj.id);
        unlinkObject(getRemoveObjectsFromLessonMutationOptions(lesson.id, objectIds))
            .then(() => {
            props.closeDialog();
            if (objectIds.length > 1) {
                enqueueSnackbar(t('deleteMultiple.success'), {
                    variant: 'success',
                });
            }
            else {
                enqueueSnackbar(t('deleteSingle.success', {
                    name: lesson.objects[0].name,
                }), {
                    variant: 'success',
                });
            }
        })
            .catch(() => {
            enqueueSnackbar(t('fallbackError'), {
                variant: 'error',
            });
        });
    };
    const isSingleObject = props.activeLesson?.objects.length === 1;
    return (_jsx(DeletionConfirmationDialog, { open: !!props.activeLesson, onClose: props.closeDialog, titleProps: {
            text: isSingleObject
                ? t('deleteSingle.title')
                : t('deleteMultiple.title'),
        }, cancelButtonProps: {
            onClick: props.closeDialog,
        }, confirmButtonProps: {
            children: isSingleObject
                ? t('deleteSingle.actions.delete')
                : t('deleteMultiple.actions.delete'),
            disabled: statusUnlinkObject.loading,
            onClick: () => {
                if (props.activeLesson)
                    onDelete(props.activeLesson);
            },
        }, children: isSingleObject
            ? t('deleteSingle.text', {
                name: props.activeLesson?.objects[0].name,
            })
            : t('deleteMultiple.text') }));
};
export default RemoveObjectsDialog;
